// 部门人员参照
/* global $ u */
import Collection from 'common/vo/collection'
import 'collection/tplFieldCertification'

import './index.less'
import operation from './opt'

let _params

function init (refer) {
  // 每次都重新加载表格
  let collection = Collection.create('templatelib_field_certificationlist')
  let code = _params.code == '' ? '0' : _params.code
  collection.load(
    {code: code, pageSize: 5},
    { url: '/cpu-supplymgr/templet/fieldCertAndEvalTempsHisPage' })

  let vm = {
    config: {
      'id': 'gridperson',
      'data': collection,
      'type': 'grid',
      'multiSelect': false,
      'editable': false,
      pagination: true,
      fields: [{
        'field': 'versionNo',
        'dataType': 'String',
        'title': '版本号',
        'width': '25%'
      }, {
        'field': 'createTime',
        'dataType': 'String',
        'title': '创建日期',
        'width': '25%',
        renderType (obj) {
          let createTime = obj.row.value.createTime
          let createDate = ''
          if (createTime) {
            createDate = createTime.split(' ')[0]
          }
          obj.element.innerHTML = '<span title="' + createDate + '">' + createDate + '</span>'
        }
      }, {
        'field': 'creatorName',
        'dataType': 'String',
        'title': '创建人',
        'width': '25%'
      }, {
        'field': 'operation',
        'title': '操作',
        'width': '25%',
        dataType: 'action',
        item: operation({
          type: _params.type
        })
      }]
    }
  }
  let app = u.createApp()
  app.init(vm, $('#tplCerHisfer')[0])
}
let template = require('./index.html')
export default function (params) {
  _params = params
  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/tplCertificationEvaluateHis/index.js